import { trackEvent } from "@/lib/posthog";

/**
 * One credit/plan-cap denial often surfaces through several catch layers
 * (edge helper, page-level classifier, app-wide cap modal). Dedupe so a single
 * incident emits ONE paywall_hit; the first (most specific) caller wins.
 *
 * Lives in its own module (not lib/posthog) so test files that partially mock
 * "@/lib/posthog" with just { trackEvent } keep working — this module then
 * calls the mocked trackEvent like any other caller.
 */
let lastPaywallHitAt = 0;

export function trackPaywallHit(
  source: string,
  detail?: {
    status?: number;
    current?: number | null;
    limit?: number | null;
    upgradeUrl?: string | null;
    resetAt?: string | null;
  },
) {
  const now = Date.now();
  if (now - lastPaywallHitAt < 5_000) return;
  lastPaywallHitAt = now;
  trackEvent("paywall_hit", {
    source,
    path: typeof window !== "undefined" ? window.location.pathname : undefined,
    ...detail,
  });
}
